import React, { useEffect, useState } from "react"
import { TextField, Snackbar, Alert, Button, Typography } from "@mui/material"
import { useAuthUser, useIsAuthenticated } from "react-auth-kit"
import { useNavigate } from "react-router-dom"
import api from "../../../../utils/api"

function CreateVotingInstancePage() {
  const isAuthenticated = useIsAuthenticated()
  const auth = useAuthUser()
  const navigate = useNavigate()

  const [username, setUsername] = useState<string>("")
  const [description, setDescription] = useState<string>("")
  const [createdAt, setCreatedAt] = useState<Date | null>(null)
  const [questionCount, setQuestionCount] = useState<number>(1)
  const [questionNum, setQuestionNum] = useState<number>(0)
  const [isSubmitting, setSubmitting] = useState(false)
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  useEffect(() => {
    isAuthenticated() ? setUsername(auth()?.username) : setUsername("")
  }, [isAuthenticated, auth])

  const handleSubmit = async () => {
    if (!description || !questionCount) {
      setErrorMessage("All fields are required")
      setOpenSnackbar(true)
      return
    }
    setSubmitting(true)

    const instanceData = {
      username,
      description,
      //values must be greater than or equal to 1
      questionCount,
      questionNum,

      createdAt,
    }
    try {
      await api.post("/admin/instances", instanceData)

      setSubmitting(false)
      navigate("/admin/dashboard", {
        state: { notification: "Instance successfully created!" },
      })
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create instance."

      console.error("There was an error:", errorMessage)
      setSubmitting(false)
    }
  }

  const handleSnackbarClose = () => {
    setOpenSnackbar(false)
    setErrorMessage("")
  }

  return (
    <>
      <Typography variant="h6" m={4}>
        Create a Voting Instance
      </Typography>

      {/* Description */}
      <TextField
        label="Description"
        value={description}
        variant="outlined"
        fullWidth
        margin="normal"
        required
        onChange={(e) => setDescription(e.target.value)}
      />

      {/* Question Count */}
      <TextField
        label="Question Count"
        type="number"
        variant="outlined"
        fullWidth
        margin="normal"
        required
        value={questionCount}
        //the minimum value for an imput must be 1 (using input props you can set max, min)
        inputProps={{ min: 1 }}
        onChange={(e) => setQuestionCount(parseInt(e.target.value, 10))}
      />

      {/* Submit Button */}
      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
        onClick={handleSubmit}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Submitting..." : "Submit"}
      </Button>

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default CreateVotingInstancePage
